<template>
  <div>
    <template>
      <v-card>
        <v-card-title>
          <span class='headline fontcolor'>{{ formTitle }}</span>
        </v-card-title>
        <v-card class='pl-7 pr-6 pt-5 pb-5'>
          <v-form ref='form' v-model='valid' lazy-validation>
            <v-row>
              <v-col>
                <v-checkbox
                  v-model='editedItem.isForLocal'
                  label="For Local Adoption"
                  color='primary'
                  value="1"
                  hint="Check if you want to add color for local adoption"
                  persistent-hint
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="this.editedItem.isForLocal === '1'" >
                <v-select
                  v-model='editedItem.year'
                  :items='codeYearList'
                  label='Year'
                  item-text="year"
                  item-value="id"
                  :disabled='Boolean(editedItem.isForLocal)'
                ></v-select>
              </v-col>
              <v-col v-else >
                <v-select
                  v-model='editedItem.year'
                  :items='codeYearList'
                  label='Year*'
                  item-text="year"
                  item-value="id"
                  :rules='yearRules'
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  v-model='editedItem.iCode'
                  :items='iCodeList'
                  label='I-Code*'
                  item-text="title"
                  item-value="abbreviation"
                  :rules='iCodeRules'
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" >
                <div style="font-size: 16px;color:#666" class="mb-1" >Color*</div>
                <v-color-picker mode="hexa" v-model="color" ></v-color-picker>
              </v-col>
            </v-row>
            <v-card-actions>
              <small color='primary'>*indicates required fields</small>
              <v-spacer></v-spacer>
              <v-btn outlined dark color='red' @click='closeDialog'>
                <v-icon dark>mdi-close</v-icon>Cancel
              </v-btn>
              <v-btn :loading='btnLoader' outlined class='fontcolor' @click='save'>
                <v-icon dark>mdi-check</v-icon>Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-card>
    </template>
  </div>
</template>

<script>
import CONSTANTS from './../../../../config/constant'

export default {
  name: 'AdminAddICodeColor',
  data: () => ({
    type: 'hex',
    hex: '#FF00FF',
    yearData: [],
    iCodeData: [],
    valid: false,
    editedIndex: -1,
    formTitle: CONSTANTS.ADD_NEW_ICODE_COLOR,
    editedItem: {
      year: '',
      iCode: '',
      color: '',
      isForLocal: ''
    },
    defaultForm: {
      year: '',
      iCode: '',
      color: '',
      isForLocal: ''
    },
    btnLoader: false,
    yearRules: [v => !!v || 'Year is required.'],
    iCodeRules: [v => !!v || 'I-Code is required.'],
    colorRules: [v => !!v || 'Color is required.']
  }),
  props: {
    userId: {
      type: Number,
      required: true
    }
  },
  computed: {
    codeYearList () {
      return this.yearData
    },
    iCodeList () {
      return this.iCodeData
    },
    color: {
      get () {
        return this[this.type]
      },
      set (v) {
        this[this.type] = v
      }
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    closeDialog () {
      this.editedItem = Object.assign({}, this.defaultForm)
      this.editedIndex = -1
      this.btnLoader = false
      this.$refs.form.resetValidation()
      this.dialog = false
      this.$emit('resetDialog', this.dialog)
    },
    save () {
      if (this.$refs.form.validate()) {
        this.btnLoader = true
        const formData = {
          userId: Number(this.userId),
          // if for local is set do not consider year field
          year: (this.editedItem.year !== undefined && Number(this.editedItem.isForLocal) !== 1) ? this.editedItem.year : '',
          iCode: (this.editedItem.iCode !== undefined) ? this.editedItem.iCode : '',
          color: (this.color !== undefined) ? this.color : '#000000',
          isForLocal: (this.editedItem.isForLocal !== undefined) ? Number(this.editedItem.isForLocal) : 0
        }
        new Promise((resolve, reject) => {
          this.$store.dispatch('ICodeColorModule/addICodeColorItem', {
            resolve,
            reject,
            formData
          })
        })
          .then(responseData => {
            this.btnLoader = false
            this.$globalStates.notification.type = 'green'
            this.$globalStates.notification.text =
              responseData.responseMessage
            this.$globalStates.notification.init_notifications = true
            this.closeDialog()
          })
          .catch(response => {
            this.btnLoader = false
            this.$globalStates.notification.type = 'error'
            this.$globalStates.notification.text = response.responseMessage
            this.$globalStates.notification.init_notifications = true
          })
      }
    },
    initialize () {
      new Promise((resolve, reject) => {
        // let status = '' // use this parameter for record statue published/inactive
        this.$store.dispatch('CodeYearModule/getCodeYearList', { resolve, reject })
      }).then((responseData) => {
        this.yearData = responseData.list
      }).catch(({ response }) => {
        this.loading = false
      })
      new Promise((resolve, reject) => {
        this.$store.dispatch('ICodeColorModule/getICodeList', { resolve, reject })
      }).then((responseData) => {
        this.iCodeData = responseData
      }).catch(({ response }) => {
        this.loading = false
      })
    }
  }
}
</script>
